webpackJsonp([114276838955818,60335399758886],{

/***/ 293:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 388:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(391);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(293);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 391:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(289);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _typography = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Template = function (_React$Component) {
	  _inherits(Template, _React$Component);
	
	  function Template() {
	    _classCallCheck(this, Template);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Template.prototype.render = function render() {
	    var _props = this.props,
	        location = _props.location,
	        children = _props.children;
	
	    var header = void 0;
	
	    var rootPath = "/";
	    if (false) {
	      rootPath = __PATH_PREFIX__ + "/";
	    }
	
	    if (location.pathname === rootPath) {
	      header = _react2.default.createElement(
	        "h1",
	        {
	          style: _extends({}, (0, _typography.scale)(1.5), {
	            marginBottom: (0, _typography.rhythm)(1.5),
	            marginTop: 0
	          })
	        },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            style: {
	              boxShadow: "none",
	              textDecoration: "none",
	              color: "inherit"
	            },
	            to: "/"
	          },
	          "The Mitchell Tesla Kansas Trip Blog"
	        )
	      );
	    } else {
	      header = _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            style: {
	              boxShadow: "none",
	              textDecoration: "none",
	              color: "inherit"
	            },
	            to: "/"
	          },
	          _react2.default.createElement(
	            "h3",
	            {
	              style: {
	                fontFamily: "Montserrat, sans-serif",
	                marginTop: 0,
	                marginBottom: 0
	              }
	            },
	            "The Mitchell Tesla Kansas Trip Blog"
	          ),
	          "< back"
	        )
	      );
	    }
	    return _react2.default.createElement(
	      "div",
	      {
	        style: {
	          marginLeft: "auto",
	          marginRight: "auto",
	          maxWidth: (0, _typography.rhythm)(24),
	          padding: (0, _typography.rhythm)(1.5) + " " + (0, _typography.rhythm)(3 / 4)
	        }
	      },
	      header,
	      children()
	    );
	  };
	
	  return Template;
	}(_react2.default.Component);
	
	exports.default = Template;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-4fdf1f91b5cdc9270d66.js